import * as React from "react";
import type { SVGProps } from "react";
const SvgSynchronize = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24" {...props}
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m22.009 12.002-2.002 2-2.001-2"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M6.342 6.344A7.98 7.98 0 0 1 12.002 4a8.003 8.003 0 0 1 8.006 8.002c0 .608-.074 1.198-.202 1.767M1.992 11.998l2.002-2 2.001 2"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M17.66 17.656A7.98 7.98 0 0 1 12 20a8.003 8.003 0 0 1-8.006-8.002c0-.608.074-1.198.202-1.767"
    />
  </svg>
);
export default SvgSynchronize;
